import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const items = [{
  left: 'Meses de desgaste que nadie compensa',
  right: 'Tu energía y bienestar que no vuelven'
}, {
  left: 'Ansiedad sin herramientas reales',
  right: 'Calidad de vida que se erosiona día a día'
}, {
  left: 'Discusiones sueltas que no resuelven nada',
  right: 'Tiempo emocional gastado sin sistema'
}, {
  left: 'Improvisar respuestas en el momento',
  right: 'Más arrepentimiento y más agotamiento'
}, {
  left: 'Manipulación que no detectás a tiempo',
  right: 'Desgaste emocional acumulado mes tras mes'
}, {
  left: 'Conflictos en pareja sin comunicación',
  right: 'Distancia que crece sin poder nombrarse'
}, {
  left: 'El mismo ciclo de postergación',
  right: 'El próximo año exactamente igual que este'
}];
export function CostSection() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-59" data-mp="1b2ldgn77g056">
      <div className="max-w-4xl mx-auto" data-id="element-60" data-mp="p7l76glybdfy">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-61" data-mp="p6s6nxdl5k69">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-62" data-mp="17y2si04gf6ra">
            ⚖️ ¿Cuánto cuesta{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-63" data-mp="1cwcq0hdnijg2">
              no tenerlo
            </span>
            ?
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-line rounded-3xl overflow-hidden shadow-sm" data-id="element-64" data-mp="136b33sx1b72q">
          <div className="grid grid-cols-2 bg-bg-warm border-b border-line" data-id="element-65" data-mp="20lkq0wo7ux5j">
            <div className="p-4 md:p-5 text-center font-bold text-ink text-sm md:text-base border-r border-line" data-id="element-66" data-mp="1vkwxg6kca897">
              Sin el ebook
            </div>
            <div className="p-4 md:p-5 text-center font-bold text-rose text-sm md:text-base" data-id="element-67" data-mp="1rlxl40wa397q">
              Costo real
            </div>
          </div>
          {items.map((it, i) => <div key={i} className={`grid grid-cols-2 ${i !== items.length - 1 ? 'border-b border-line' : ''}`} data-id="element-68" data-mp="1hsqksugeajei" data-mpi={i}>
              <div className="p-4 md:p-5 flex items-start gap-2.5 border-r border-line" data-id="element-69" data-mp="17wn66p4cwsao">
                <XIcon className="w-4 h-4 text-rose flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-70" data-mp="13us7lsdt8t0l" />
                <span className="text-sm md:text-base text-ink" data-id="element-71" data-mp="yvpcaznmu15t">{it.left}</span>
              </div>
              <div className="p-4 md:p-5 text-sm md:text-base text-ink-soft italic" data-id="element-72" data-mp="3ai0wmsv44k3n">
                {it.right}
              </div>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mt-10" data-id="element-73" data-mp="3jkilzg62dsuv">
          <p className="font-serif-italic text-ink text-xl md:text-2xl mb-2" data-id="element-74" data-mp="2vu635a9a6bpi">
            El próximo paso en tu camino puede empezar hoy.
          </p>
          <p className="font-serif-italic text-rose text-lg md:text-xl" data-id="element-75" data-mp="35j68rciag5co">
            "Tu paz mental merece protección." 🌸
          </p>
        </motion.div>
      </div>
    </section>;
}